export default {
  release: '18.4',
  date: 'September 2025',
  releasePostUrl: 'https://docs.gitlab.com/releases/18/gitlab-18-4-released/#this-months-notable-contributor-patrick-rice',
  contributors: [
    {
      name: 'Patrick Rice',
      gitlabUsername: 'PatrickRice',
    },
  ],
  writeUp: `Patrick Rice continues his exceptional dedication to GitLab's open source community as contributor, maintainer,
and mentor.
A [top 5 contributor](https://contributors.gitlab.com/leaderboard?fromDate=2025-01-01&toDate=2025-09-18&search=&communityOnly=true)
over the past year, Patrick maintains the [GitLab Terraform Provider](https://gitlab.com/gitlab-org/terraform-provider-gitlab)
and [client-go](https://gitlab.com/gitlab-org/api/client-go) projects,
handling feature additions, releases, issue triage, and community onboarding.
He embodies GitLab's mission that everyone can contribute, having worked his way up from
contributor to project maintainer.

Patrick's impact extends beyond code contributions to community building and coaching,
helping new contributors get started and grow in the project.
Patrick previously nominated and supported Heidi Berry who won the [17.11 Notable Contributor award](https://about.gitlab.com/releases/2025/04/17/gitlab-17-11-released/#notable-contributor).
He also shared insights with the [GitLab for Education](https://about.gitlab.com/solutions/education/)
team on working with students learning GitLab to help us grow the next generation of developers.

"I'd love to encourage new contributors to join us in collaborating on the Terraform Provider
and client-go projects," Patrick says.
"We can always use more friendly faces in our community."

"Patrick has continued relentlessly supporting the GitLab team and customers," says [Lee Tickett](https://gitlab.com/leetickett-gitlab),
Staff Fullstack Engineer at GitLab, who nominated Patrick for the award.
[Timo Furrer](https://gitlab.com/timofurrer), Senior Backend Engineer at GitLab, supported the nomination.
"Apart from his daily contributions to the Terraform Provider and client-go," Timo adds,
"he's helping GitLab customers directly with their IaC journey by showcasing what is possible with the
GitLab Terraform Provider."

Patrick is an Enterprise Architect at Kingland and member of the [GitLab Community Core Team](https://about.gitlab.com/community/core-team/).
This marks his second Notable Contributor award, having [previously won in GitLab 15.8](https://about.gitlab.com/releases/2023/01/22/gitlab-15-8-released/#mvp) in January 2023.

Thanks to Patrick for his sustained contributions and dedication to supporting GitLab customers
and growing our open source community!`,
};
